module.exports = __webpack_public_path__ + "img/list-vert.03db7a0a.svg";